var _defs, _rect, _rect2, _rect3, _rect4, _g, _rect5, _g2, _rect6, _rect7, _g3, _rect8, _rect9, _rect10, _rect11, _g4, _rect12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScenarioPipe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 116.03 168.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .clsd-1{fill:none;}.clsd-2{clip-path:url(#clip-path);}.clsd-3{clip-path:url(#clip-path-2);}.clsd-4{opacity:0.55;}.clsd-5{fill:#63c4dd;}.clsd-6{fill:#38bad9;}.clsd-7{fill:#0294bd;}.clsd-8{clip-path:url(#clip-path-3);}.clsd-9{fill:#25a2c6;}.clsd-10{fill:#4fc0db;}.clsd-11{fill:#a9dae7;}.clsd-12{fill:#67c5de;}\n        "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "clsd-1",
    x: 32.09,
    y: 193.36,
    width: 114.64,
    height: 147.24,
    transform: "translate(-189.13 308.1) rotate(-79.88)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "clsd-1",
    d: "M153,220.11a4.9,4.9,0,0,0-.77-.06L27.59,218.7a5.13,5.13,0,0,0-5.18,5.07l-.15,13.6,134.92,1.46.15-13.61a5.13,5.13,0,0,0-4.14-5.08Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "clsd-1",
    x: 0.26,
    width: 117.04,
    height: 168.56
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "clsd-5",
    x: 51.87,
    y: 73.6,
    width: 2.72,
    height: 4.55
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "clsd-6",
    x: 48.77,
    y: 78.08,
    width: 8.92,
    height: 2.76
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "clsd-7",
    x: 108.73,
    width: 7.31,
    height: 81.18
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "clsd-7",
    x: 70.11,
    y: 80.83,
    width: 38.73,
    height: 7.31
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "clsd-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "clsd-9",
    d: "M107.4,89.36h.14a9.78,9.78,0,0,0,9.77-9.78H107.4Z"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "clsd-7",
    x: 65.26,
    y: 87.38,
    width: 7.31,
    height: 81.18
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "clsd-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "clsd-9",
    d: "M73.89,79.2h-.13A9.78,9.78,0,0,0,64,89h9.91Z"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "clsd-10",
    x: 0.26,
    y: 65.92,
    width: 81.18,
    height: 7.31
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "clsd-10",
    x: 81.09,
    y: 73.12,
    width: 7.31,
    height: 38.73
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "clsd-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "clsd-6",
    d: "M89.62,74.55a.57.57,0,0,0,0-.13,9.76,9.76,0,0,0-9.77-9.77v9.9Z"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "clsd-11",
    x: 33.21,
    y: 40.66,
    width: 7.31,
    height: 81.18
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "clsd-6",
    x: 50.15,
    y: 63.99,
    width: 6.22,
    height: 11.17
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "clsd-6",
    x: 18.07,
    y: 63.99,
    width: 6.22,
    height: 11.17
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "clsd-11",
    x: 27.17,
    y: 83.63,
    width: 6.15,
    height: 3.42
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "clsd-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "clsd-12",
    d: "M28.52,81.05a2.14,2.14,0,1,1-2.14-2.13,2.14,2.14,0,0,1,2.14,2.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsd-12",
    d: "M28.52,85.38a2.14,2.14,0,1,1-2.14-2.14,2.13,2.13,0,0,1,2.14,2.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsd-12",
    d: "M28.52,89.65a2.14,2.14,0,1,1-2.14-2.14,2.14,2.14,0,0,1,2.14,2.14"
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "clsd-12",
    x: 31.39,
    y: 81.35,
    width: 11.06,
    height: 8.06
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenarioPipe);
export default __webpack_public_path__ + "static/media/scenario-pipe.fad24f32.svg";
export { ForwardRef as ReactComponent };